const downloadLogSummary = async (params) => {
  try {
    const token = localStorage.getItem("token");
    let queryParams = [];

    if (params.customerId) queryParams.push(`customerId=${params.customerId}`);
    if (params.functionId) queryParams.push(`functionId=${params.functionId}`);
    if (params.startDate) queryParams.push(`startDate=${params.startDate}`);
    if (params.endDate) queryParams.push(`endDate=${params.endDate}`);
    if (params.batchId != null) queryParams.push(`batchId=${params.batchId}`);
    if (params.isAutoLogSummary !== undefined)
      queryParams.push(`isAutoLogSummary=${params.isAutoLogSummary}`);
    if (params.poNumber !== null)
      queryParams.push(`poNumber=${params.poNumber}`);

    const downloadUrl = `${
      process.env.REACT_APP_BASE_URL
    }/api/LogSummary/downloadexcel?${queryParams.join("&")}`;

    const response = await fetch(downloadUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/")) {
      const blob = await response.blob();
      const fileUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = fileUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      throw new Error("The response is not a valid file type.");
    }
    let newWindow = null;

    if (params.customerId) {
      if (params?.batchId != null) {
        if (params?.poNumber !== null) {
          newWindow = window.open(
            `${downloadUrl}?customerId=${params.customerId}&functionId=${params.functionId}&startDate=${params.startDate}&endDate=${params.endDate}&batchId=${params.batchId}&isAutoLogSummary=${params.isAutoLogSummary}&poNumber=${params.poNumber}`,
            "_blank"
          );
        } else {
          newWindow = window.open(
            `${downloadUrl}?customerId=${params.customerId}&functionId=${params.functionId}&startDate=${params.startDate}&endDate=${params.endDate}&batchId=${params.batchId}&isAutoLogSummary=${params.isAutoLogSummary}`,
            "_blank"
          );
        }
      } else {
        if (params?.poNumber !== null) {
          newWindow = window.open(
            `${downloadUrl}?customerId=${params.customerId}&functionId=${params.functionId}&startDate=${params.startDate}&endDate=${params.endDate}&isAutoLogSummary=${params.isAutoLogSummary}&poNumber=${params.poNumber}`,
            "_blank"
          );
        } else {
          newWindow = window.open(
            `${downloadUrl}?customerId=${params.customerId}&functionId=${params.functionId}&startDate=${params.startDate}&endDate=${params.endDate}&isAutoLogSummary=${params.isAutoLogSummary}`,
            "_blank"
          );
        }
      }
    } else {
      if (params?.batchId != null) {
        if (params?.poNumber !== null) {
          newWindow = window.open(
            `${downloadUrl}?functionId=${params.functionId}&startDate=${params.startDate}&endDate=${params.endDate}&batchId=${params.batchId}&isAutoLogSummary=${params.isAutoLogSummary}&poNumber=${params.poNumber}`,
            "_blank"
          );
        } else {
          newWindow = window.open(
            `${downloadUrl}?functionId=${params.functionId}&startDate=${params.startDate}&endDate=${params.endDate}&batchId=${params.batchId}&isAutoLogSummary=${params.isAutoLogSummary}`,
            "_blank"
          );
        }
      } else {
        if (params?.poNumber !== null) {
          newWindow = window.open(
            `${downloadUrl}?functionId=${params.functionId}&startDate=${params.startDate}&endDate=${params.endDate}&isAutoLogSummary=${params.isAutoLogSummary}&poNumber=${params.poNumber}`,
            "_blank"
          );
        } else {
          newWindow = window.open(
            `${downloadUrl}?functionId=${params.functionId}&startDate=${params.startDate}&endDate=${params.endDate}&isAutoLogSummary=${params.isAutoLogSummary}`,
            "_blank"
          );
        }
      }
    }
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("Failed to open a new window.");
    }
  } catch (error) {
    if (error?.code?.trim() == "ERR_NETWORK") {
      throw new Error(
        "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
      );
    } else {
      throw new Error(error?.response?.data?.title);
    }
  }
};

export default downloadLogSummary;
